import { Attribute, ChangeDetectorRef, ElementRef, Inject, IterableDiffers, NgModule } from '@angular/core';
import { CdkTable, CdkTableModule } from '@angular/cdk/table';
import { ElBidiModule } from '../bidi/bidi.module';
import { ElDirectionality } from '../bidi/bidi-service';
import { ElPlatformModule } from '../platform/platform.module';
import { ElPlatform } from '../platform/platform-service';
import { EL_DOCUMENT } from '../../../theme.options';
import {
    ElCellDefDirective,
    ElCellDirective,
    ElColumnDefDirective,
    ElFooterCellDefDirective,
    ElFooterCellDirective,
    ElHeaderCellDefDirective,
    ElHeaderCellDirective,
} from './cell';
import {
    ElCellOutletDirective,
    ElDataRowOutletDirective,
    ElFooterRowOutletDirective,
    ElHeaderRowOutletDirective,
    ElFooterRowComponent,
    ElFooterRowDefDirective,
    ElHeaderRowComponent,
    ElHeaderRowDefDirective,
    ElRowComponent,
    ElRowDefDirective,
} from './row';

export const EL_TABLE_TEMPLATE = `
  <ng-container elHeaderRowOutlet></ng-container>
  <ng-container elRowOutlet></ng-container>
  <ng-container elFooterRowOutlet></ng-container>`;

export class ElTable<T> extends CdkTable<T> {
    constructor(
        differs: IterableDiffers,
        changeDetectorRef: ChangeDetectorRef,
        elementRef: ElementRef,
        @Attribute('role') role: string,
        dir: ElDirectionality,
        @Inject(EL_DOCUMENT) document: any,
        platform: ElPlatform | undefined,
    ) {
        super(differs, changeDetectorRef, elementRef, role, dir, document, platform);
    }
}

const COMPONENTS = [
    ElTable,

    // Template defs
    ElHeaderCellDefDirective,
    ElHeaderRowDefDirective,
    ElColumnDefDirective,
    ElCellDefDirective,
    ElRowDefDirective,
    ElFooterCellDefDirective,
    ElFooterRowDefDirective,

    // Outlets
    ElDataRowOutletDirective,
    ElHeaderRowOutletDirective,
    ElFooterRowOutletDirective,
    ElCellOutletDirective,

    // Cell directives
    ElHeaderCellDirective,
    ElCellDirective,
    ElFooterCellDirective,

    // Row directives
    ElHeaderRowComponent,
    ElRowComponent,
    ElFooterRowComponent,
];

@NgModule({
    imports: [ElBidiModule, ElPlatformModule],
    declarations: [...COMPONENTS],
    exports: [...COMPONENTS],
})
export class ElTableModule extends CdkTableModule { }
